import { useEffect, useRef, useState } from "react"

export function useInView<T extends HTMLElement>(
  options?: IntersectionObserverInit,
) {
  const ref = useRef<T | null>(null)
  const [isInView, setIsInView] = useState(false)
  const optionsRef = useRef(options)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true)
        observer.disconnect()
      }
    }, optionsRef.current)

    observer.observe(node)

    return () => observer.disconnect()
  }, [])

  return { ref, isInView }
}
